import React, { useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const GUESTHOUSE_API_BASE = `${API_ROOT}/api/guesthouse`;

const nw = { whiteSpace: "nowrap" };

function today() {
  return new Date().toISOString().slice(0, 10);
}

function fmtDateTime(v) {
  if (!v) return "-";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yy} ${hh}:${mi}`;
}

export default function SmsLogs() {
  const user = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);

  const moduleId = parseInt(user?.moduleId, 10);

  const [fromDate, setFromDate] = useState(today());
  const [toDate,   setToDate]   = useState(today());
  const [rows,     setRows]     = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [searched, setSearched] = useState(false);

  if (![4, 10].includes(moduleId)) {
    return (
      <section className="container-fluid">
        <div className="alert alert-danger mt-3">Unauthorized access Or Session Timed out.</div>
      </section>
    );
  }

  const fetchData = async () => {
    if (!fromDate || !toDate) { setError("Please select both From Date and To Date."); return; }
    try {
      setLoading(true); setError(""); setRows([]);
      const q = new URLSearchParams({ moduleId: String(moduleId), fromDate, toDate });
      const res = await fetch(`${GUESTHOUSE_API_BASE}/sms-logs?${q}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to fetch");
      setRows(Array.isArray(data) ? data : []);
      setSearched(true);
    } catch (err) {
      setError(err.message || "Failed to fetch SMS logs");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="container-fluid">
      <h3 className="ctitle">SMS Logs</h3>

      <div className="row g-3 align-items-end mb-3">
        <div className="col-md-2">
          <label className="form-label">From Date</label>
          <input className="form-control" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        </div>
        <div className="col-md-2">
          <label className="form-label">To Date</label>
          <input className="form-control" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        </div>
        <div className="col-md-auto d-flex align-items-end">
          <button type="button" className="btn btn-primary" onClick={fetchData} disabled={loading}>
            View
          </button>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading && <div className="text-muted mb-2">Loading...</div>}

      {!loading && searched && (
        <div className="table-responsive">
          <table
            className="table table-bordered table-striped table-hover table-sm align-middle"
            style={{ borderCollapse: "collapse", "--bs-table-border-color": "#000", "--bs-table-hover-bg": "#aed6f1" }}
          >
            <thead style={{ "--bs-table-bg": "#008080", color: "white" }}>
              <tr>
                <th style={nw}>S.No</th>
                <th style={nw}>Mobile</th>
                <th>Message</th>
                <th style={nw}>Status</th>
                <th style={nw}>Time Log</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">No records found for the selected dates.</td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={row.id || idx}>
                    <td style={nw}>{idx + 1}</td>
                    <td style={nw}>{row.mobile_number || ""}</td>
                    <td>{row.message || ""}</td>
                    <td style={nw}>{row.status || ""}</td>
                    <td style={nw}>{fmtDateTime(row.log_time)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
